import { useEffect } from 'react';

/**
 * Normal page scrolling for document-style pages (About, Help, Terms / Privacy, Subscribe…).
 *
 * index.css sets `body { overflow: hidden }` because the editor shell is a fixed viewport that manages its own scroll
 * regions. A long public page rendered in that body cannot be scrolled with the wheel, keys or a finger (only programmatic
 * scrolling still works). While such a page is mounted the body scrolls like an ordinary web page; the editor's value is put
 * back when it unmounts.
 */
export const usePageScroll = () => {
  useEffect(() => {
    const body = document.body;
    const prev = body.style.overflow;
    body.style.overflow = 'auto';
    body.classList.add('wp-page-scroll');
    return () => {
      body.style.overflow = prev;
      body.classList.remove('wp-page-scroll');
    };
  }, []);
};
